import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { Stream } from 'types/stream';
import { OffsetPaginated } from 'types/pagination';

import { useAPI } from 'hooks/api/useAPI';
import { useUser } from 'hooks/useAuth';
import { updateWorkspaceBooleanTrait } from 'services/customer_tracking';

import { useStreams, UseStreamsParams } from './useStreams';

export function useInputStreams(
  params?: UseStreamsParams,
  options?: UseQueryOptions<OffsetPaginated<Stream>, APIError>
) {
  const api = useAPI();
  const user = useUser();

  return useStreams({
    params: {
      stream_types: ['rtsp', 'webrtc'],
      sources: ['uri_stream'],
      ...params,
    },
    ...options,
    onSuccess: (pages) => {
      if (!user?.id) {
        return;
      }

      updateWorkspaceBooleanTrait({
        userId: user.id,
        workspaceId: api.applicationID,
        trait: 'has_input_streams',
        value: pages.data.length > 0,
      });
    },
  });
}
